module.exports = __webpack_public_path__ + "static/img/til98.e5b9f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til98.png
// module id = GC/T
// module chunks = 1